// @story HIR-HR26
// The vacancy's document chase list (server: services/eligibility.service.js):
// candidates whose eligibility has something not stated, and only the
// documents this post needs from each. Not stated is never a rejection; this
// list only says whom to ask for what. Nothing here sends a message.
import React, { useEffect, useState } from 'react';
import api from '../../services/api';
import { Card, CardHeader } from '../../ds';

export default function DocumentChaseList({ jobId }) {
  const [data, setData] = useState(null);
  const [err, setErr] = useState('');
  useEffect(() => {
    if (!jobId) return undefined;
    let live = true;
    api.get(`/cv-scoring/vacancies/${jobId}/chase-list`)
      .then((r) => { if (live) setData(r.data?.data || null); })
      .catch((e) => { if (live) setErr(e.response?.data?.message || 'Could not read the chase list just now.'); });
    return () => { live = false; };
  }, [jobId]);

  if (err) return <p style={{ color: 'var(--status-danger-text)', fontSize: 'var(--fs-body-sm)' }}>{err}</p>;
  if (!data || !Array.isArray(data.chase)) return null;
  const c = data.counts || {};
  return (
    <Card>
      <CardHeader title="Eligibility and documents to chase" subtitle={`${c.meets || 0} meet · ${c['not met'] || 0} not met · ${c['not stated'] || 0} not stated${data.ruleset?.provisional ? ' · provisional rules' : ''}`} />
      {data.chase.length === 0 ? (
        <p style={{ fontSize: 'var(--fs-body-sm)', color: 'var(--text-2)', margin: 0 }}>Nobody needs to send documents for this post.</p>
      ) : (
        <ul style={{ margin: 0, paddingLeft: 18, fontSize: 'var(--fs-body-sm)' }}>
          {data.chase.map((r) => (
            <li key={r.candidateId}>
              {r.name} <span style={{ color: 'var(--text-muted)' }}>· {r.documents.join(', ')}</span>
            </li>
          ))}
        </ul>
      )}
      <p style={{ fontSize: 'var(--fs-caption)', color: 'var(--text-muted)', marginTop: 8 }}>{data.note}</p>
    </Card>
  );
}
